import { createApp } from 'vue';
import App from '../components/Advices.vue';

createApp(App)
  .mount('#advices');
